import { render, staticRenderFns } from "./NewConcessionPermitApplication.vue?vue&type=template&id=b568641e"
import script from "./NewConcessionPermitApplication.vue?vue&type=script&lang=ts"
export * from "./NewConcessionPermitApplication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports